
import { useCookies } from 'react-cookie';

export const antiForgeryFormOptions = () => {
    const [cookies] = useCookies();

    return {
        withCredentials: true,
        headers: { RequestVerificationToken: cookies[antiForgeryToken] }
    };
};

export const antiForgeryToken = 'X-CSRF-TOKEN';
